import React from 'react';
import './TeamGameCounts.css';

function TeamGameCounts({ teams, weeklyGames }) {
 const gameCountMap = {};

 teams.forEach((team) => {
  let count = 0;
  Object.values(weeklyGames).forEach((games) => {
   if (Array.isArray(games)) {
    games.forEach((game) => {
     if (game.team1_id === team.id || game.team2_id === team.id) {
      count++;
     }
    });
   }
  });

  if (!gameCountMap[count]) {
   gameCountMap[count] = [];
  }
  gameCountMap[count].push(team.name);
 });

 const sortedCounts = Object.keys(gameCountMap).sort((a, b) => a - b);

 return (
  <div className="team-game-counts">
   {sortedCounts.map((count) => (
    <div key={count} className="game-group">
     <h4>{count} {count === '1' ? 'game' : 'games'}</h4>
     <div className="team-list-row">
      {gameCountMap[count].map((team, index) => (
       <span key={index} className="team-name">{team}</span>
      ))}
     </div>
    </div>
   ))}
  </div>
 );
}

export default TeamGameCounts;
